import {useContext, useMemo} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close'
import {Field} from '@adv-mt/ui/field'
import {Selector} from '@adv-mt/ui/selector'

const ComplaintTypeField = ({complaintTypeId, hasAttemptedSubmit, isProfessional, onChange, className = ''}) => {
  const {domain, i18n} = useContext(Context)

  const {ORDERED_DEALER_COMPLAINT_TYPES, ORDERED_PRIVATE_COMPLAINT_TYPES} = domain.get('config').get('report')
  const complaintTypes = isProfessional ? ORDERED_DEALER_COMPLAINT_TYPES : ORDERED_PRIVATE_COMPLAINT_TYPES

  const items = useMemo(
    () => Object.fromEntries(complaintTypes.map(complaintType => [complaintType.id, i18n.t(complaintType.text)])),
    [complaintTypes, i18n]
  )

  const isInvalid = hasAttemptedSubmit && !complaintTypeId

  const handleValueChange = value => {
    onChange({complaintTypeId: value || undefined})
  }

  return (
    <Field.Root className={className}>
      <Field.Label>{i18n.t('AD_COMPLAINT.COMPLAINT_REASON')}</Field.Label>
      <Selector.Root items={items} value={complaintTypeId || ''} onValueChange={handleValueChange}>
        <Selector.Trigger aria-invalid={isInvalid || undefined} placeholder={i18n.t('COMMON.SELECT')} />
        <Selector.Popup>
          {complaintTypes.map(complaintType => (
            <Selector.Item key={complaintType.id} value={complaintType.id} truncate={false}>
              {i18n.t(complaintType.text)}
            </Selector.Item>
          ))}
        </Selector.Popup>
      </Selector.Root>
      {isInvalid && (
        <Field.Error match icon={<IconClose />}>
          {i18n.t('AD_COMPLAINT.COMPLAINT_REASON_REQUIRED_ERROR_TEXT')}
        </Field.Error>
      )}
    </Field.Root>
  )
}

ComplaintTypeField.propTypes = {
  complaintTypeId: PropTypes.string,
  hasAttemptedSubmit: PropTypes.bool,
  isProfessional: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
}

export default ComplaintTypeField
